export { default as HtmlRenderer } from './component';
